module.exports = __webpack_public_path__ + "img/ipylogo108.766c89fa.png";